import { call, put, select, takeLatest } from 'redux-saga/effects'
import { handleApiErrors } from '../../../lib/api-errors'
import axiosApi from '../../../views/client/axiosClient'

import {
  TWO_FA_REQUESTING,
  TWO_FA_REQUEST_SUCCESS,
  TWO_FA_POSTING,
  TWO_FA_SUCCESS,
  TWO_FA_ERROR,
  TWO_FA_GET_API,
  TWO_FA_POST_API,
} from './constants'

import {
  twoFASettingRequestSuccess,
  twoFASettingRequestError
} from './actions'

const getTwoFASettingState = state => state.twoFASetting;

function twoFASettingRequestApi () {
  return axiosApi().get(TWO_FA_GET_API)
    .then(handleApiErrors)
    .then( function(response){
      return response.data
    })
    .then(json => json)
    .catch((error) => { throw error })
}

function twoFASettingPostApi (formData) {
  return axiosApi().post(TWO_FA_POST_API, 
    {
      mfa_code: formData.mfa_code
    })
    .then(handleApiErrors)
    .then( function(response){
      return response.data
    })
    .then(json => json)
    .catch((error) => { throw error })
}

function* twoFASettingRequestFlow () {
  try {
    // call to our myaccountsRequestApi function with the client
    const response = yield call(twoFASettingRequestApi)
    yield put({ type: TWO_FA_REQUEST_SUCCESS, data: response.user })

  } catch (error) {
    yield put({ type: TWO_FA_ERROR, error: error })
  }
}

function* twoFASettingPostFlow (formData) {
  const twoFASetting = yield select(getTwoFASettingState);

  try {
    // call to our myaccountsRequestApi function with the client
    const response = yield call(twoFASettingPostApi, twoFASetting.postData)
    if (response.code != 200){
      yield put({ type: TWO_FA_ERROR, error: response.message })
    }
    else {
      yield put({ type: TWO_FA_SUCCESS, data: response })
    }

  } catch (error) {
    yield put({ type: TWO_FA_ERROR, error: error })
  }
}

function* twoFASettingWatcher () {
  yield takeLatest(TWO_FA_REQUESTING, twoFASettingRequestFlow)
  yield takeLatest(TWO_FA_POSTING, twoFASettingPostFlow)
}

export default twoFASettingWatcher



// WEBPACK FOOTER //
// ./src/views/Pages/TwoFASetting/sagas.js